export default "__VITE_ASSET__a155879e__"